import { AppGlobalActions } from '@app/_store/actions/global.actions';
import { UnloadedMetaContainer } from '@core/models/general-types/general-types';
import { BillsharkProviders } from '@core/models/interfaces/storage-data/billshark';
import { createFeature, createReducer, on } from '@ngrx/store';

import { BillsharkProvidersActions } from './billshark-providers.actions';

export type BillsharkProvidersState = UnloadedMetaContainer<BillsharkProviders>;

export const initialBillsharkProvidersState: BillsharkProvidersState = {
  collection: [],
  metaData: null,
};

const billsharkProvidersReducer = createReducer(
  initialBillsharkProvidersState,
  on(AppGlobalActions.loadAppDataSuccess, (state, { globalState }) =>
    // R37. `...(globalState.billsharkProviders ?? {})` produced a new state object even
    // when this container was not part of the response, so a one-container
    // load handed all 23 feature slices a new reference and nothing else.
    globalState.billsharkProviders
      ? { ...state, ...globalState.billsharkProviders }
      : state
  ),
  on(
    BillsharkProvidersActions.loadBillsharkProvidersSuccess,
    (state, { billsharkProviders }) => ({
      ...state,
      ...billsharkProviders,
    })
  )
);

export const billsharkProvidersFeature = createFeature({
  name: 'billsharkProviders',
  reducer: billsharkProvidersReducer,
  extraSelectors: ({ selectBillsharkProvidersState }) => ({
    selectBillsharkProvidersState,
  }),
});
